module.exports = __webpack_public_path__ + "static/media/PlutoLight.78881940.otf";